<template>
    <el-row :gutter="20">
        <el-col :span="8">
            <el-card>
                <div slot="header">
                    <span>权限列表</span>
                    <el-button style="float: right; padding: 3px 0" type="text" @click="handleNodeClick({value: 0})">新增</el-button>
                </div>
                <el-tree ref="tree" :data="treeData" node-key="value"
                         :expand-on-click-node="false" :highlight-current=true :default-expanded-keys="expandedKeys"
                         @node-click="handleNodeClick">
                    <div class="el-tree-node__label" slot-scope="{node, data}">
                        <span>{{node.label}}</span>&nbsp;&nbsp;
                        <el-tag size="mini" v-if="data.type === 'LINK'">{{$utils.getEnumLabel('permission.type', data.type)}}</el-tag>
                    </div>
                </el-tree>
            </el-card>
        </el-col>
        <el-col :span="16">
            <Config ref="config" :id="id" @success="loadPermissions" v-if="showConfig"></Config>
        </el-col>
    </el-row>
</template>
<script>
    import Config from "./Config.vue"

    export default {
        components: {
            Config,
        },
        data() {
            return {
                id: -1,
                permissions: [],
                treeData: [],
                expandedKeys: [],
                showConfig: true
            }
        },
        provide() {
            return {
                getPermissions: () => {
                    return this.permissions
                },
                getTreeData: () => {
                    return this.treeData
                }
            }
        },
        beforeMount() {
            this.loadPermissions(-1);
        },
        methods: {
            loadPermissions(current) {
                this.expandedKeys = [];
                this.handleNodeClick({value: current});

                this.$axios.post("/permission/list", {
                    orders: {
                        "ordered": "asc"
                    }
                }).then(response => {
                    this.permissions = response.data;
                    this.treeData = this.getChildren(0);

                    this.$nextTick(() => {
                        this.expandedKeys = this.$refs.config.getParents(current);
                        this.$refs.tree.setCurrentKey(current);
                    });
                })
            },
            getChildren(id) {
                let children = [];
                this.permissions.forEach(permission => {
                    if (permission['parentId'] === id) {
                        children.push({
                            label: permission['name'],
                            value: permission['id'],
                            type: permission['type'],
                            children: this.getChildren(permission['id'])
                        });
                    }
                });
                return children.length < 1 ? null : children;
            },
            handleNodeClick(data) {
                this.showConfig = false;
                this.$nextTick(() => {
                    this.id = data['value'];
                    this.showConfig = true;
                });
            },
        }
    }
</script>